import { render, staticRenderFns } from "./FacadePhotoViewer.vue?vue&type=template&id=70617588&scoped=true"
import script from "./FacadePhotoViewer.vue?vue&type=script&lang=js"
export * from "./FacadePhotoViewer.vue?vue&type=script&lang=js"
import style0 from "./FacadePhotoViewer.vue?vue&type=style&index=0&id=70617588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70617588",
  null
  
)

export default component.exports